// @TODO: placement incorrect on full page - might be a container setting in docs

import { Draggable } from '@shopify/draggable';

export class ImageHotspots {
  constructor(el) {
    if (!el) return;
    this.el = el;
    this.init();
  }

  init() {
    let containerRect;
    let dragRect;
    let dragRectPercX;
    let dragRectPercY;
    let positionX;
    let positionY;

    // initialize draggable library
    const draggable = new Draggable(this.el, {
      draggable: '.js-base-hotspot-draggable',
    });

    // set relevant variables when drag item is created
    draggable.on('mirror:created', (evt) => {
      containerRect = evt.sourceContainer.getBoundingClientRect();
      dragRect = evt.source.getBoundingClientRect();
      dragRectPercX = (dragRect.width / containerRect.width) * 100;
      dragRectPercY = (dragRect.height / containerRect.height) * 100;
    });

    // update variables with current coordinates of dragged item
    draggable.on('mirror:move', (evt) => {
      positionX =
        evt.sensorEvent.clientX - containerRect.left - dragRect.width / 2;
      positionY =
        evt.sensorEvent.clientY - containerRect.top - dragRect.height / 2;
    });

    // figure out percentages of coordinates,
    // check that the dragged item is not outside the parent element
    // call updatePosition
    draggable.on('drag:stop', (evt) => {
      let percentX = (positionX / containerRect.width) * 100;
      let percentY = (positionY / containerRect.height) * 100;

      percentX = this.checkBoundary(percentX, dragRectPercX);
      percentY = this.checkBoundary(percentY, dragRectPercY);

      this.updatePosition(evt, percentX.toFixed(1), percentY.toFixed(1));
    });
  }

  // make sure dragged element has not left the bounds of the parent container
  checkBoundary(position, size) {
    if (position > 100 - size) {
      position = 100 - size;
    } else if (position < 0) {
      position = 0;
    }

    return position;
  }

  // use this function to set the data on the relevant elements
  updatePosition(evt, x, y) {
    evt.data.originalSource.style.left = x + '%';
    evt.data.originalSource.style.top = y + '%';

    document.getElementById('coordx').value = x;
    document.getElementById('coordy').value = y;
  }
}
